'use strict';

// var paypal = require('../paypal/paypal');
// var wishlist = require('../product/wishlist');
const toastHelpers = require('core/components/toast');

function addProduct(data) {
	const uuid = data.uuid || null;
	const pid = data.pid || null;
	const addProductUrl = data.action || null;
	const productName = data.name || null;

	$.spinner().start();

	$.ajax({
		url: addProductUrl,
		method: 'POST',
		dataType: 'json',
		data: {
			pid: pid,
			uuid: uuid,
			name: productName
		},
		success: function(response) {
			const alertType = response.success ? 'success' : 'warning';
			toastHelpers.methods.show(alertType, response.msg, false);
			updateCartData();
		},
		error: function(error) {
			console.error('Save For Later Failed:', error);
			$.spinner().stop();
		}
	});
}

function removeProduct(data, skipMsg) {
	const uuid = data.uuid || null;
	const pid = data.pid || null;
	const removeProductUrl = data.action || null;
	const productName = data.name || null;

	$.ajax({
		url: removeProductUrl,
		method: 'GET',
		dataType: 'json',
		data: {
			pid: pid,
			uuid: uuid,
			name: productName
		},
		success: function(response) {
			if (!skipMsg) {
				const alertType = response.success ? 'success' : 'warning';
			    toastHelpers.methods.show(alertType, response.msg, false);
			}
			updateCartData();
		},
		error: function(error) {
			console.error('Remove From Save For Later Failed:', error);
			$.spinner().stop();
		}
	});
}

function moveToCart(data) {
	const uuid = data.uuid || null;
	const pid = data.pid || null;
	const addToCartUrl = data.action || null;
	const productName = data.name || null;

	$.spinner().start();

	$.ajax({
		url: addToCartUrl,
		method: 'POST',
		dataType: 'json',
		data: {
			pid: pid,
			uuid: uuid,
			name: productName,
			quantity: 1
		},
		success: function(response) {
			const alertType = response.error ? 'warning' : 'success';
			toastHelpers.methods.show(alertType, response.message, false);
			if (response.error === false) {
				$('.empty-cart-content').hide();
				data.action = data.removeaction;
				removeProduct(data, true);
			}
		},
		error: function(error) {
			console.error('Add To Cart Failed:', error);
			$.spinner().stop();
		}
	});
}

function updateCartData() {
    $.spinner().stop();
    $.spinner().start();
    window.location.reload();
}

module.exports = {
	saveProductForLater: function() {
		$('body').on('click', '.save-for-later-btn', function(e) {
			e.preventDefault();
			addProduct($(this).data());
		});
	},
	removeProductSavedForLater: function() {
		$('body').on('click', '.remove-save-for-later-btn', function(e) {
			e.preventDefault();
			removeProduct($(this).data());
		});
	},
	addToCartSavedForLater: function() {
		$('body').on('click', '.move-to-cart-save-for-later-btn', function(e) {
			e.preventDefault();
			moveToCart($(this).data());
		});
	},
	updateCartData: function() {
		$('body').on('cart:updateData', updateCartData);
	}
};
